export const ResourceRecordFormWizard = ({ children }) => children ?? null
